import KeybeRepository from '@/shared/infrastructure/repositories/KeybeRepository'
import { dataToGetPartnerUtmInformation } from '../../domain/PartnersController'
import { GenericResponse } from '@/shared/infrastructure/http/GenericResponse'
import { HeadersBuilder } from '@/shared/infrastructure/http/HeadersBuilder'
import { nonGetOptions } from '@/shared/infrastructure/http/HttpClient'

export default class PartnersRepository extends KeybeRepository {
  getSuggestionsAbortController: AbortController

  constructor () {
    super()

    this.getSuggestionsAbortController = new AbortController()
  }

  abortGetSuggestions () {
    this.getSuggestionsAbortController.abort()
    this.getSuggestionsAbortController = new AbortController()
  }

  async getPartnerUtmInformation (data: dataToGetPartnerUtmInformation): Promise<GenericResponse> {
    const url = `${process.env.VUE_APP_FEES_URL}/user/check`
    const headers = HeadersBuilder.buildSimpleAutorizationHeader(data)
    delete data.token
    const requestOptions: nonGetOptions = {
      headers,
      url,
      data: { email: data.email },
      abortController: this.getSuggestionsAbortController
    }

    return await this.client.post(requestOptions)
  }
}
